import React, { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { LOCATION_NAMES, formatDate } from "@/lib/format";
import { Modal } from "@/components/ui/kit";
import { toast } from "sonner";

const TYPES = {
  venta: ["Venta", "text-red-500"], anulacion: ["Anulación", "text-emerald-500"], pedido_online: ["Pedido online", "text-red-500"],
  compra: ["Compra", "text-emerald-500"], traslado_entrada: ["Traslado recibido", "text-emerald-500"],
  traslado_salida: ["Traslado enviado", "text-red-500"], ajuste: ["Ajuste", "text-amber-500"],
};

export const MovementsModal = ({ product, onClose }) => {
  const [data, setData] = useState(null);
  const [type, setType] = useState("");
  useEffect(() => {
    if (!product) return;
    setData(null); setType("");
    api.get(`/products/${product.id}/movements`).then((r) => setData(r.data)).catch((e) => { toast.error(apiErr(e)); onClose(); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);
  const rows = (data?.movements || []).filter((m) => !type || m.type === type);
  const sum = (t) => (data?.movements || []).filter((m) => t.includes(m.type)).reduce((a, m) => a + m.qty, 0);
  return (
    <Modal open={!!product} onClose={onClose} title={`Movimientos · ${product?.name || ""}`} wide top>
      {!data ? <p className="text-sm text-muted-foreground text-center py-8">Cargando…</p> : (
        <div className="space-y-4" data-testid="movements-modal">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-center">
            {[["STOCK ACTUAL", data.stock, "text-primary"], ["COMPRAS", sum(["compra"]), "text-emerald-500"],
              ["VENTAS", sum(["venta", "pedido_online", "anulacion"]), "text-red-500"], ["TRASLADOS", sum(["traslado_entrada", "traslado_salida"]), "text-amber-500"]].map(([l, v, c]) => (
              <div key={l} className="rounded-lg bg-secondary p-2"><p className="text-[10px] font-bold tracking-widest text-muted-foreground">{l}</p><p className={`font-data font-bold ${c}`}>{v > 0 && l !== "STOCK ACTUAL" ? `+${v}` : v}</p></div>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <p className="text-xs text-muted-foreground flex-1">Local: {LOCATION_NAMES[data.location]}</p>
            <select value={type} onChange={(e) => setType(e.target.value)} data-testid="movements-type" className="h-9 px-2 rounded-lg bg-secondary border border-border text-sm">
              <option value="">Todos</option>
              {Object.entries(TYPES).map(([k, [l]]) => <option key={k} value={k}>{l}</option>)}
            </select>
          </div>
          <div className="max-h-[55vh] overflow-y-auto">
            <table className="w-full text-sm" data-testid="movements-table">
              <thead><tr className="text-left text-[10px] tracking-widest text-muted-foreground border-b border-border"><th className="py-2 pr-2">FECHA</th><th className="pr-2">TIPO</th><th className="pr-2 text-right">CANT.</th><th className="pr-2">USUARIO</th><th>DETALLE</th></tr></thead>
              <tbody>
                {rows.map((m, i) => (
                  <tr key={i} className="border-b border-border/50" data-testid={`movement-${i}`}>
                    <td className="py-1.5 pr-2 text-xs whitespace-nowrap">{formatDate(m.date)}</td>
                    <td className={`pr-2 text-xs font-semibold ${TYPES[m.type]?.[1]}`}>{TYPES[m.type]?.[0] || m.type}</td>
                    <td className={`pr-2 text-right font-data font-bold ${m.qty >= 0 ? "text-emerald-500" : "text-red-500"}`}>{m.qty > 0 ? `+${m.qty}` : m.qty}</td>
                    <td className="pr-2 text-xs">{m.user || "-"}</td>
                    <td className="text-xs text-muted-foreground">{m.ref && <span className="font-data mr-1">#{m.ref}</span>}{m.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {rows.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">Sin movimientos</p>}
          </div>
        </div>
      )}
    </Modal>
  );
};
